"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormImportCtrl = void 0;
const tslib_1 = require("tslib");
const core_shared_1 = require("@ikegps/core-shared");
const mobx_1 = require("mobx");
const notification_service_1 = require("../../components/notification.toast/notification.service");
const i18n_1 = require("../../i18n");
const services_1 = require("../../services");
const mobx_2 = require("../../state/mobx");
const store_1 = require("../../store");
const upload_reader_1 = require("../../util/upload.reader");
class FormImportCtrl extends mobx_2.MobxState {
    constructor() {
        super();
        this.file = null;
        this.isActive = false;
        this.validationErrors = [];
        this.validationWarnings = [];
        this.validationInfo = [];
        this.secondaryFormId = null;
        this.lastAttachmentId = null;
        this.lastAttachmentName = null;
        this.fileId = 'file-' + core_shared_1.IkeId.generate();
    }
    reset() {
        this.file = null;
        this.validationErrors = [];
        this.validationWarnings = [];
        this.validationInfo = [];
        this.lastAttachmentId = null;
        this.lastAttachmentName = null;
    }
    openFileDialog(e) {
        e.preventDefault();
        const fileInput = document.getElementById(this.fileId);
        if (fileInput == null) {
            throw new Error('Unable to find file input: "' + this.fileId + "'");
        }
        const evt = document.createEvent('MouseEvents');
        evt.initEvent('click', true, false);
        fileInput.dispatchEvent(evt);
    }
    onFile(e) {
        const fileInput = e.target;
        if (fileInput == null) {
            throw new Error('Unable to find file input: "' + this.fileId + "'");
        }
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.FormImportUpload, 'file:click', 'button', 1);
        this.loadFiles(fileInput.files);
    }
    loadFiles(files) {
        this.file = null;
        if (!files || files.length === 0) {
            return;
        }
        const file = files[0];
        const hasAllowedSuffix = FormImportCtrl.ALLOWED_SUFFIXES.some((suffix) => file.name.endsWith(suffix));
        if (!hasAllowedSuffix) {
            notification_service_1.NotificationService.error({ key: i18n_1.T.FILE_NOT_SUPPORTED });
            return;
        }
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.FormImportUpload, 'file:count', '1', 1);
        this.file = new upload_reader_1.UniversalFileUploadReader(file, undefined);
    }
    getImportName(attachmentName) {
        const regexPattern = FormImportCtrl.REPLACED_SUFFIXES.map((suffix) => '\\' + suffix).join('|');
        const regex = new RegExp(regexPattern, 'g');
        return attachmentName.replace(regex, '');
    }
    validateFile() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e;
            if (this.file && this.file.buffer) {
                const rest = services_1.Services.Department.rest;
                try {
                    const attachment = yield rest.Attachment.set(this.file.name, this.file.buffer, this.file.type);
                    this.lastAttachmentId = attachment.objectId;
                    this.lastAttachmentName = attachment.name;
                    const response = yield rest.Form.Pla.import(Object.assign(Object.assign({ attachmentId: attachment.objectId, name: this.getImportName(attachment.name) }, (this.secondaryFormId && { revision: this.secondaryFormId })), { validateOnly: true }));
                    this.validationWarnings = (_a = response === null || response === void 0 ? void 0 : response.warnings) !== null && _a !== void 0 ? _a : [];
                    this.validationInfo = (_b = response === null || response === void 0 ? void 0 : response.info) !== null && _b !== void 0 ? _b : [];
                }
                catch (e) {
                    if (core_shared_1.IkeRequestError.isIkeRequestError(e)) {
                        this.validationErrors = (_c = e.errors) !== null && _c !== void 0 ? _c : [];
                        this.validationWarnings = (_d = e.warnings) !== null && _d !== void 0 ? _d : [];
                        this.validationInfo = (_e = e.info) !== null && _e !== void 0 ? _e : [];
                    }
                    this.file = null;
                    throw e;
                }
            }
        });
    }
    createForm() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this.lastAttachmentId || !this.lastAttachmentName) {
                throw new Error('No validated attachment to create form from');
            }
            const rest = services_1.Services.Department.rest;
            yield rest.Form.Pla.import(Object.assign({ attachmentId: this.lastAttachmentId, name: this.getImportName(this.lastAttachmentName) }, (this.secondaryFormId && { revision: this.secondaryFormId })));
            yield store_1.AppStore.FormSummary.refresh();
        });
    }
    processFile() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e;
            if (this.file && this.file.buffer) {
                const rest = services_1.Services.Department.rest;
                try {
                    const attachment = yield rest.Attachment.set(this.file.name, this.file.buffer, this.file.type);
                    const response = yield rest.Form.Pla.import(Object.assign({ attachmentId: attachment.objectId, name: this.getImportName(attachment.name) }, (this.secondaryFormId && { revision: this.secondaryFormId })));
                    this.validationWarnings = (_a = response === null || response === void 0 ? void 0 : response.warnings) !== null && _a !== void 0 ? _a : [];
                    this.validationInfo = (_b = response === null || response === void 0 ? void 0 : response.info) !== null && _b !== void 0 ? _b : [];
                    yield store_1.AppStore.FormSummary.refresh();
                }
                catch (e) {
                    if (core_shared_1.IkeRequestError.isIkeRequestError(e)) {
                        this.validationErrors = (_c = e.errors) !== null && _c !== void 0 ? _c : [];
                        this.validationWarnings = (_d = e.warnings) !== null && _d !== void 0 ? _d : [];
                        this.validationInfo = (_e = e.info) !== null && _e !== void 0 ? _e : [];
                    }
                    this.file = null;
                    throw e;
                }
            }
        });
    }
}
exports.FormImportCtrl = FormImportCtrl;
FormImportCtrl.COMMON_SUFFIXES = ['.csv', '.db', '.lccfg', '.client'];
FormImportCtrl.ALLOWED_SUFFIXES = [...FormImportCtrl.COMMON_SUFFIXES, '.xlsx', '.dds'];
FormImportCtrl.REPLACED_SUFFIXES = [...FormImportCtrl.COMMON_SUFFIXES, '.poleforeman.xlsx'];
tslib_1.__decorate([
    mobx_1.observable.shallow
], FormImportCtrl.prototype, "file", void 0);
tslib_1.__decorate([
    mobx_1.observable
], FormImportCtrl.prototype, "isActive", void 0);
tslib_1.__decorate([
    mobx_1.observable.shallow
], FormImportCtrl.prototype, "validationErrors", void 0);
tslib_1.__decorate([
    mobx_1.observable.shallow
], FormImportCtrl.prototype, "validationWarnings", void 0);
tslib_1.__decorate([
    mobx_1.observable.shallow
], FormImportCtrl.prototype, "validationInfo", void 0);
tslib_1.__decorate([
    mobx_1.action.bound
], FormImportCtrl.prototype, "reset", null);
tslib_1.__decorate([
    mobx_1.action.bound
], FormImportCtrl.prototype, "openFileDialog", null);
tslib_1.__decorate([
    mobx_1.action.bound
], FormImportCtrl.prototype, "onFile", null);
tslib_1.__decorate([
    mobx_1.action.bound
], FormImportCtrl.prototype, "validateFile", null);
tslib_1.__decorate([
    mobx_1.action.bound
], FormImportCtrl.prototype, "createForm", null);
tslib_1.__decorate([
    mobx_1.action.bound
], FormImportCtrl.prototype, "processFile", null);
//# sourceMappingURL=form.import.ctrl.js.map